import Phaser from 'phaser';

import {
    nbRails,
    difficultyIncreaseEventDelay,
    difficultyIncreaseStep,
    difficultyStart,
    difficultyLimit
}                        from '../../constants/appConstants';
import ScoreManager      from '../ScoreManager/ScoreManager';
import Rail              from '../Rail/Rail';
import Boat              from '../Boat/Boat';
import SpawnManager      from '../SpawnManager/SpawnManager';
import BackgroundManager from '../BackgroundManager/BackgroundManager';
import InputManager      from '../InputManager/InputManager';


class MainScene extends Phaser.Scene {
    constructor ( config ) {
        super( config );
        Phaser.Scene.call(this, { key: 'MainScene' });
    }

    init () {
        // initialise value
        this._difficutlyEvent = null;
        this._difficulty = difficultyStart;

        // create element
        this._inputManager = new InputManager( this );
        this._backgroundManager = new BackgroundManager( this );
        this._scoreManager = new ScoreManager( this );

        this._rails = [];
        for ( let i = 0; i < nbRails; i++ )
            this._rails.push( new Rail( this, i, nbRails ) );

        this._animalsManager = new SpawnManager( this, this.rails );
        this._boat = new Boat( this, this.rails[Math.floor( nbRails / 2 )] );

        // connect element
        // this._inputManager.onSwipeLeft( this._boat.onMoveLeft.bind( this._boat ) );
        // this._inputManager.onSwipeRight( this._boat.onMoveRight.bind( this._boat ) );
        this._inputManager.onKeyLeft( this._boat.onMoveLeft.bind( this._boat ) );
        this._inputManager.onKeyRight( this._boat.onMoveRight.bind( this._boat ) );
        this._inputManager.onClickLeft( this._boat.onMoveLeft.bind( this._boat ) );
        this._inputManager.onClickRight( this._boat.onMoveRight.bind( this._boat ) );
    }

    preload () {
        this._backgroundManager.preload();
        this._scoreManager.preload();
        this._rails.forEach( rail => rail.preload() );
        this._animalsManager.preload();
        this._boat.preload();
    }

    create () {
        this._backgroundManager.create();
        this._scoreManager.create();
        this._rails.forEach( rail => rail.create() );
        this._animalsManager.create();
        this._boat.create();

        this._difficutlyEvent = this.time.addEvent( {
            delay: difficultyIncreaseEventDelay,
            callback: this.increaseDifficulty,
            callbackScope: this,
            loop: true
        } );
    }


    update ( time, delta ) {
        this._backgroundManager.update();
        this._scoreManager.update();
        this._rails.forEach( rail => rail.update() );
        this._animalsManager.update();
        this._boat.update();
    }


    increaseDifficulty () {
        if ( this._difficulty < difficultyLimit ) {
            this._difficulty += difficultyIncreaseStep;
            this._animalsManager.onDifficultyUpdate( this._difficulty );
        }
    }

    get difficulty () {
        return this._difficulty;
    }

    get rails () {
        return this._rails || [];
    }

    get boat () {
        return this._boat;
    }

    get animalsManager () {
        return this._animalsManager;
    }

    get scoreManager () {
        return this._scoreManager;
    }

    forcePause(){
        this.scene.pause();
    }
}

export default MainScene;
